import React from 'react';

export type LinkWrapperProps = {
  href: string;
  className?: string;
  target?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  dynamicQueryParamsToIgnore?: string[];
  prefetch?: boolean;
  scroll?: boolean;
  children: React.ReactNode;
};

export type LinkWrapper = (props: LinkWrapperProps) => JSX.Element | null;

const DefaultLinkWrapper: LinkWrapper = ({
  href,
  className,
  target,
  onClick,
  children,
}) => (
  <a href={href} className={className} target={target} onClick={onClick}>
    {children}
  </a>
);

export default DefaultLinkWrapper;
